<template>
  <div>
    <div v-for="item in markerList">
      <scene-view-marker-selecting :markerInfo="item"></scene-view-marker-selecting>
    </div>
  </div>
</template>

<script>
import SceneViewMarkerSelecting from "@/views/globe/globe_marker/SceneViewMarker_selecting";

export default {
  name: "SceneViewMarkerEntrySelecting",
  props:['markerList'],
  components: {SceneViewMarkerSelecting},
}
</script>

<style scoped>

</style>